
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/variants/[slug]",
      function () {
        return require("private-next-pages/variants/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/variants/[slug]"])
      });
    }
  